"use strict";
// reference: https://git.woa.com/tencent-cloud-commerce-platform/tccp-strategy/blob/master/strategy-model/src/main/java/com/tencent/tccp/strategy/model/enums/ActionEnum.java
Object.defineProperty(exports, "__esModule", { value: true });
exports.FilterOperatorEnum = void 0;
var FilterOperatorEnum;
(function (FilterOperatorEnum) {
    /** 相等 */
    FilterOperatorEnum["StringEqual"] = "string_equal";
    /** 不等 */
    FilterOperatorEnum["StringNotEqual"] = "string_not_equal";
    /** 在集合内 */
    FilterOperatorEnum["StringIn"] = "string_in";
    /** 不在集合内 */
    FilterOperatorEnum["StringNotIn"] = "string_not_in";
    /** 数字相等 */
    FilterOperatorEnum["NumberEqual"] = "number_equal";
    /** 数字不相等 */
    FilterOperatorEnum["NumberNotEqual"] = "number_not_equal";
    /** 数字大于 */
    FilterOperatorEnum["NumberGreaterThan"] = "number_greater_than";
    /** 数字大于等于 */
    FilterOperatorEnum["NumberGreaterThanEqual"] = "number_greater_than_equal";
    /** 数字小于 */
    FilterOperatorEnum["NumberLessThan"] = "number_less_than";
    /** 数字小于等于 */
    FilterOperatorEnum["NumberLessThanEqual"] = "number_less_than_equal";
    /** 数字在数组中 */
    FilterOperatorEnum["NumberIn"] = "number_in";
    /** 数字不在数组中 */
    FilterOperatorEnum["NumberNotIn"] = "number_not_in";
    /** 数字在a和b之间，包含a和b */
    FilterOperatorEnum["NumberBetween"] = "number_between";
    /** 数字在a和b之间，不包含a和b */
    FilterOperatorEnum["NumberNotBetween"] = "number_not_between";
    /** 日期相等 */
    FilterOperatorEnum["DateEqual"] = "date_equal";
    /** 日期不相等 */
    FilterOperatorEnum["DateNotEqual"] = "date_not_equal";
    /** 日期大于 */
    FilterOperatorEnum["DateGreaterThan"] = "date_greater_than";
    /** 日期大于等于 */
    FilterOperatorEnum["DateGreaterThanEqual"] = "date_greater_than_equal";
    /** 日期小于 */
    FilterOperatorEnum["DateLessThan"] = "date_less_than";
    /** 日期小于等于 */
    FilterOperatorEnum["DateLessThanEqual"] = "date_less_than_equal";
    /** 日期在数组中 */
    FilterOperatorEnum["DateIn"] = "date_in";
    /** 日期不在数组中 */
    FilterOperatorEnum["DateNotIn"] = "date_not_in";
    /** 日期在a和b之间，包含a和b */
    FilterOperatorEnum["DateBetween"] = "date_between";
    /** 日期在a和b之间，不包含a和b */
    FilterOperatorEnum["DateNotBetween"] = "date_not_between";
})(FilterOperatorEnum || (exports.FilterOperatorEnum = FilterOperatorEnum = {}));
